export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const UPDATE_SCENES = 'UPDATE_SCENES';
